/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1DispositioncodesQueryResponse } from '../../types/GetV1Dispositioncodes.ts'

export const getV1DispositioncodesQueryKey = () => [{ url: '/v1/DispositionCodes' }] as const

export type GetV1DispositioncodesQueryKey = ReturnType<typeof getV1DispositioncodesQueryKey>

/**
 * {@link /v1/DispositionCodes}
 */
export async function getV1Dispositioncodes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1DispositioncodesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/DispositionCodes`, ...requestConfig })
    return res
}

export function getV1DispositioncodesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1DispositioncodesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1DispositioncodesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1DispositioncodesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Dispositioncodes(config)
        },
    })
}

/**
 * {@link /v1/DispositionCodes}
 */
export function useGetV1Dispositioncodes<
    TData = ResponseConfig<GetV1DispositioncodesQueryResponse>,
    TQueryData = ResponseConfig<GetV1DispositioncodesQueryResponse>,
    TQueryKey extends QueryKey = GetV1DispositioncodesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1DispositioncodesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1DispositioncodesQueryKey()

    const query = useQuery(
        {
            ...getV1DispositioncodesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
